var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.36708 1.20043C5.36708 0.813595 5.70286 0.5 6.11708 0.5H10.883C11.2972 0.5 11.633 0.813595 11.633 1.20043C11.633 1.58727 11.2972 1.90087 10.883 1.90087H6.11708C5.70286 1.90087 5.36708 1.58727 5.36708 1.20043Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.82936 3.44675H15.1706C15.9048 3.44675 16.5 4.00028 16.5 4.6831C16.5 5.36592 15.9048 5.91945 15.1706 5.91945H1.82936C1.09518 5.91945 0.5 5.36592 0.5 4.6831C0.5 4.00028 1.09518 3.44675 1.82936 3.44675Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5956 4.15653C15.0099 4.15653 15.3456 4.47013 15.3456 4.85697V17.4C15.3456 18.9709 14.1925 20.5 12.4866 20.5H4.65463C2.94875 20.5 1.7956 18.9709 1.7956 17.4V8.48892C1.7956 8.10208 2.13139 7.78849 2.5456 7.78849C2.95982 7.78849 3.2956 8.10208 3.2956 8.48892V17.4C3.2956 18.4686 4.04058 19.0991 4.65463 19.0991H12.4866C13.1007 19.0991 13.8456 18.4686 13.8456 17.4V4.85697C13.8456 4.47013 14.1814 4.15653 14.5956 4.15653Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.95111 8.72076C7.36532 8.72076 7.70111 9.03435 7.70111 9.42119V17.0198C7.70111 17.4066 7.36532 17.7202 6.95111 17.7202C6.53689 17.7202 6.20111 17.4066 6.20111 17.0198V9.42119C6.20111 9.03435 6.53689 8.72076 6.95111 8.72076Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0492 8.72076C10.4634 8.72076 10.7992 9.03435 10.7992 9.42119V17.0198C10.7992 17.4066 10.4634 17.7202 10.0492 17.7202C9.63496 17.7202 9.29918 17.4066 9.29918 17.0198V9.42119C9.29918 9.03435 9.63496 8.72076 10.0492 8.72076Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.a0c4ace1b2a8bee309e391ce698204f8.svg";
export { ForwardRef as ReactComponent };